/**
 * Real contact number, matches `hero-content.tsx`'s `WHATSAPP_HREF` (kept
 * separate/duplicated there intentionally — that one's a fixed CTA and
 * shouldn't start depending on calculator code).
 *
 * Phase 6 (Questionnaire & Contact) will migrate the actual `#kontakt` form
 * the live site's calculator CTA scrolls to and pre-fills. Until that
 * exists, the calculator's "include in inquiry" buttons open WhatsApp with
 * the computed summary pre-filled instead — a real, already-working contact
 * channel on this site, rather than a dead link to a section that doesn't
 * exist yet. Revisit this in Phase 6 once `#kontakt` lands.
 */
const WHATSAPP_NUMBER = '38761722891'

export function whatsappHref(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}

/**
 * Real Formspree endpoint, same one the live site's `#contactForm` posts to
 * (index.html, form action). Used by `InquiryModal` (calculator "add to
 * inquiry" CTAs) so a real lead lands in the same inbox the live site
 * already delivers to, ahead of Phase 6 building the full `#kontakt` form.
 */
export const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xdavebqn'
